// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"538f9ce2","305":"a033d39a","400":"81d3f54c","685":"be0b1201","763":"16d43903"}[chunkId] + ".chunk.js";
};